import { mapState, mapGetters, mapActions } from 'vuex';
//import _ from 'lodash';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import PzButton from '@/components/PzButton.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';
import SelectBookMenu from '@/views/Bookmark/components/SelectBookMenu.vue';
import SelectCourseMenu from '@/views/Bookmark/components/SelectCourseMenu.vue';
import EmptyVideoList from '@/views/Bookmark/components/VideoList/EmptyVideoList.vue';
import VideoList from '@/views/Bookmark/components/VideoList/VideoList.vue';

import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';
import { AddToFavoriteListMixin } from '@/mixins/Bookmark/AddToFavoriteList';
import { BookmarkMixin } from '@/mixins/Bookmark';
import { FavoriteSelectBookMixin } from '@/mixins/Bookmark/FavoriteSelectBook';
import { FavoriteSelectCourseMixin } from '@/mixins/Bookmark/FavoriteSelectCourse';

import { LOADING_MESSAGE } from './Bookmark.constants';

export default {
  name: 'Bookmark',

  mixins: [
    ClassRestrictionMixin,
    AddToFavoriteListMixin,
    BookmarkMixin,
    FavoriteSelectBookMixin,
    FavoriteSelectCourseMixin,
  ],

  components: {
    WayFindBar,
    Footer,
    Aside,
    //TabBar,
    PzButton,
    Spinner,
    Player,
    SelectBookMenu,
    SelectCourseMenu,
    EmptyVideoList,
    VideoList,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('Bookmark', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    ///
    c_courseId() {
      return this.mg_selectedVideo.courseId;
    },

    ///
    c_restrictStudent() {
      return this.mg_selectedVideo.restrictStudent;
    },
  },

  methods: {
    ...mapActions('Bookmark', {
      ma_getBookmark: 'getBookmark',
    }),

    ///
    async doGetFavoriteList() {
      await this.ma_getBookmark({
        courseId: 0,
        bookId: 0,
      });
    },
  },

  created() {
    this.selectCourse(-1);
    if (this.c_isLogin) {
      this.getFavoriteList();
    }
    this.$bus.once('login-modal-closed', this.getFavoriteList);
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  beforeDestroy() {
    this.$bus.off('login-modal-closed', this.getFavoriteList);
  },
};
